import { ajaxDelete, ajaxPost } from "core/js/spring-ajax";

const AUTHENTICATION_EMAIL_URL = `/authentication/rest/authentication-email`;

export async function resendAuthenticationEmail() {
  await ajaxPost({
    url: AUTHENTICATION_EMAIL_URL,
  });
}

export async function cancelAuthenticationEmail(userId: number) {
  await ajaxDelete({
    url: `${AUTHENTICATION_EMAIL_URL}/${userId}`,
  });
}
